import React, { useEffect, useState } from "react";
import { PRIMARY_COLOR } from "../../assets/style/colors";
import DateRange from "../../Component/DateRange/DateRange";
import { Table2 } from "../../Component/Table/Table2";
import { admin_list } from "../redux/api/dummyJson";
import { copyIcon } from "../../assets/img";
import { toast } from "react-toastify";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Loader from "../../Component/Loader";
import { Toast } from "../../Component/Toast";
import moment from "moment/moment";
import useStore from "../../LocalStore/useStore";
import CustomScroll from "../../Component/CustomScroll";

const ReferFriends = () => {
  const { kv, set } = useStore();
  const Refer_obj = kv.refer_obj || [];
  const Refer_code = kv.refer_code || "";
  const Refer_url = kv.refer_url || "";
  const Refer_size = kv.refer_size || 0;

  const [pagination, setPagination] = useState("");
  const [page, setPage] = useState(1);
  const [copySuccess, setCopySuccess] = useState(false);

  const [referralCode, setReferralCode] = useState(Refer_code);
  const [referralUrl, setReferralUrl] = useState(Refer_url);
  const [teamSize, setTeamSize] = useState(Refer_size);

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState("");
  const [data, setData] = useState(Refer_obj);

  const getList = async () => {
    try {
      // if (!kv.refer_code || !kv.refer_url || !kv.refer_size) {
      //   setLoading(true);
      // }

      const res = await get(`${URLS.REFERRAL}/share`);
      // // console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        setReferralCode(res?.data?.referral_code);
        setReferralUrl(res?.data?.referral_url);
        setTeamSize(res?.data?.team_size);
        set("refer_code", res?.data?.referral_code);
        set("refer_url", res?.data?.referral_url);
        set("refer_size", res?.data?.team_size);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const historyList = async (date_) => {
    try {
      if (!kv.refer_obj || kv.refer_obj.length === 0) {
        setLoading(true);
      }
      let url_ = `/earn/history?page=${page}`;
      if (date_) {
        url_ = url_ + `&date=${moment(date_).format("YYYY-MM-DD")}`;
      }
      setFormData(date_);
      const res2 = await get(`${URLS.REFERRAL + url_}`);
      if (res2.status === "success") {
        setData(res2?.data);
        set("refer_obj", res2?.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    historyList(new Date());
  }, [page]);

  useEffect(() => {
    getList();
  }, []);

  const handleCopy = () => {
    // Check if modern clipboard API is available
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(referralUrl)
        .then(() => showCopySuccess())
        .catch(() => fallbackCopy(referralUrl));
    } else {
      fallbackCopy(referralUrl);
    }
  };

  // ✅ Fallback copy method (works even in HTTP/local)
  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed"; // avoid scrolling to bottom
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      showCopySuccess();
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  const showCopySuccess = () => {
    setCopySuccess(true);
    Toast(`copied to clipboard`);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "created_at",
        Cell: ({ value }) => <p>{value}</p>,
      },
      {
        Header: "Betting Amount",
        accessor: "betting_amount",
        Cell: ({ value }) => <p>{value}</p>,
      },
      {
        Header: "Commission Amount",
        accessor: "amount",
        Cell: ({ value }) => <p>{value}</p>,
      },
    ],
    [],
  );

  const totalAmount = data?.reduce((sum, item) => sum + item.amount, 0);

  const formatCurrency = (amount) => `₹ ${amount.toLocaleString()}`;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <div className="dashRightView p-0">
      <CustomScroll>
        <div style={{ padding: "15px", marginBottom: 50 }}>
           <p
              style={{ color: PRIMARY_COLOR,
                textAlign : 'center',
                marginBottom:'5px'
              }}
              className="f3"
            >
              Your Referral Code
            </p>
          <div className="d-flex ac-js w-100" style={{ alignItems: "center" }}>
            
            <div className="text-center copy-input">
              
              <input
                className="f2"
                type="text"
                style={{ color: "black", top: isIOS ? 0 : 2 }}
                value={referralCode}
                readOnly
              />
            </div>
             <div className="d-flex ac-js position-relative">
            <button
              onClick={handleCopy}
              style={{ cursor: "pointer", border: "none" }}
            >
              <div className="search-btn f3"  style={{top:'-23px' ,right:'-65px' ,height:'48px',width:'110px'}}>Copy</div>
            </button>
            </div>
          </div>

          <div className="d-flex my-4 py-2 ac-js gap-3">
            <p
              style={{ color: PRIMARY_COLOR}}
              className="f3"
            >
              Your Team Size
            </p>
            <input
              type="number"
              value={teamSize}
              readOnly
              style={{ height: 32, color: "#000000ff", fontSize: 16 }}
              className="input-box-team w-25 f3 fs-16 text-center p-1"
            />
          </div>

          <div className="my-4">
            <DateRange
              onChange={(dates) => historyList(dates)}
              fromDate={formData}
            />
          </div>
          <Table2
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={data}
            show={false}
            removePagination={true}
          // loading={loading}
          />
        </div>
      </CustomScroll>
      <div className="screen-pagination">
        <div
          className="d-flex ac-jb bg-primary1 white p-2 px-3"
          style={{ marginBottom: 3 }}
        >
          <p className="f3 white fs-xs-14 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
            Total Amount
          </p>
          <p className="f3 fs-xs-14 white fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24">
            {formatCurrency(totalAmount)}
          </p>
        </div>
      </div>
      {/* {loading && <Loader />} */}
    </div>
  );
};

export default ReferFriends;
